import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  mutation updateWorkflowName($projectId: String!, $input: UpdateWorkflowNameInput!) {
    updateWorkflowName(projectId: $projectId, input: $input) {
      ...WorkflowFields
    }
  }
`
